export default "__VITE_ASSET__Bjhh_z4r__"